import { merge } from 'lodash-es';
import { FC, useCallback, useRef, useState } from 'react';
import { FormFieldsContainer } from '../../../components/Form/FormComponents';
import { StickyFormButtons } from '../../../components/Form/StickyFormButtons';
import { ITransactionDataModel } from '../../../data-models/transaction.data-model';
import { IUpdateTransactionPayload } from '../../../services/queries/MaggieTransactionQueries';
import { captureFormValidationError } from '../../../util/SentryUtils';
import { toTransactionDataModel } from '../../../view-models/transaction-form.view-model';
import { TransactionForm, TransactionFormMethodsRef } from './TransactionForm';

interface IEditTransactionFormProps {
  transaction: ITransactionDataModel;
  onSubmit: (transaction: IUpdateTransactionPayload) => Promise<ITransactionDataModel | undefined>;
  onCancel: () => void;
}

export const EditTransactionForm: FC<IEditTransactionFormProps> = ({ transaction, onSubmit, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const ref = useRef<TransactionFormMethodsRef | null>(null);

  const handleSubmit = useCallback(async () => {
    const formRef = ref.current;
    if (!formRef) {
      return false;
    }

    const formIsValid = await formRef.methods.trigger();
    if (!formIsValid) {
      captureFormValidationError('Transaction form edit submit', formRef.methods.formState.errors);
      return false;
    }

    setLoading(true);
    const data = merge({}, formRef.methods.formState.defaultValues, formRef.methods.getValues());
    const payload = toTransactionDataModel(data);
    await onSubmit(payload as IUpdateTransactionPayload);
    setLoading(false);
  }, [onSubmit]);

  return (
    <>
      <FormFieldsContainer>
        <TransactionForm
          companyId={transaction.companyId}
          title=''
          transactionTypeId={transaction.transactionTypeId}
          transactionData={transaction}
          ref={ref}
        />
      </FormFieldsContainer>
      <StickyFormButtons onCancel={onCancel} onSubmit={handleSubmit} loading={loading} />
    </>
  );
};
